import { TDictionary } from '@/common/types/dictionary';

export type TOrganizationType = TDictionary<OrganizationTypes>;

export enum OrganizationTypes {
  FOIV = 1, // ФОИВ
  MEP_DEPARTMENT = 2, // Департамент МЭР
  ZAGRANAPARAT = 3, // Загранаппарат
  RF_SUBJECT = 4, // Субъект РФ
}
